import { render, staticRenderFns } from "./DocumentIndex.vue?vue&type=template&id=460e1bf8&scoped=true"
import script from "./DocumentIndex.vue?vue&type=script&lang=js"
export * from "./DocumentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460e1bf8",
  null
  
)

export default component.exports